import { useEffect, useRef, useState } from "react";
import { CLOSE_ICON } from "../../cufront-assets/icons/Icons";
import "../css/CustomField.css";
import OtherIcons from "./OtherIcons";
import { useItemsFilter } from "../../_helper/actions/app/items";
import { useAtom } from "jotai";
import { clinicAtom } from "../../_helper/constant/constant-atom";
import { useCreateItem } from "../../_helper/actions/mutation/items";
import CuInput from "../../all-patient/components/CuInput";
import { toast } from "react-toastify";
import { capitalizeFirstWord } from "../../_helper/utils/utils";
import { CONSULTATION_APIS } from "../constants/_constant";
import Popup from "../../common_component/component/Popup";

export const filterByTagType = (data, tagType) => {
  return data?.filter((item) => item?.tag_type?.includes(tagType));
};

const CustomField = ({
  data,
  customfields,
  setCustomfields,
  addictions,
  setAddictions,
  allergies,
  setAllergies,
  patientHistory,
  setPatientHistory,
  billingServices,
  setBillingServices,
}) => {
  const [items, setItems] = useState([]);
  const [searchInput, setSearchInput] = useState("");
  const [debounceSearch, setDebounceSearch] = useState("");
  const [clinic] = useAtom(clinicAtom);
  const [selectedOption, setSelectedOption] = useState(0);
  const containerRef = useRef(null);
  const optionRef = useRef([]);

  let query = `?name=${debounceSearch}`;

  if (data?.offset === "TAGS") {
    query = `?name=${debounceSearch}&tag_type=${data?.tagId}`;
  }

  if (data?.offset === "CLINIC_SERVICES") {
    query = `?action=getClinicServices&fronted=True&clinic_id=${clinic?.id}&name_of_service=${debounceSearch}`;
  }

  const { data: customFieldData, isLoading } = useItemsFilter(
    CONSULTATION_APIS[data?.offset],
    query,
    data && debounceSearch?.length > 0 ? true : false
    // "",
    // 0
  );

  useEffect(() => {
    if (data) {
      if (data?.label === "Allergy") {
        setItems(allergies || []);
        return;
      }
      if (data?.label === "Patient History") {
        setItems(patientHistory || []);
        return;
      }
      if (data?.label === "Addictions") {
        setItems(addictions || []);
        return;
      }
      if (data?.label === "Billing") {
        setItems(billingServices || []);
        return;
      }
      setItems(filterByTagType(customfields, data?.tagId) || []);
    }
  }, [data, customfields, allergies, addictions, billingServices]);

  const handleSearch = (val) => {
    // if (val?.length === 0) {
    //   setOptions([]);
    // }
    setSearchInput(val);
  };

  useEffect(() => {
    const id = setTimeout(() => {
      setDebounceSearch(searchInput);
    }, 250);

    return () => clearTimeout(id);
  }, [searchInput]);

  const handleSelectOption = (val) => {
    if (data?.label === "Addictions") {
      const isAlreadyExist = addictions?.findIndex(
        (adc) => adc?.id === val?.id
      );
      if (isAlreadyExist === -1) {
        setItems((prev) => [...prev, val]);
        setAddictions((prev) => [...prev, val]);
      } else {
        toast.error(`${val?.name} already exist`);
      }
    } else if (data?.label === "Allergy") {
      const isAlreadyExist = allergies?.findIndex((adc) => adc?.id === val?.id);
      if (isAlreadyExist === -1) {
        setItems((prev) => [...prev, val]);
        setAllergies((prev) => [...prev, val]);
      } else {
        toast.error(`${val?.name} already exist`);
      }
    } else if (data?.label === "Patient History") {
      const isAlreadyExist = patientHistory?.findIndex(
        (adc) => adc?.id === val?.id
      );
      if (isAlreadyExist === -1) {
        setItems((prev) => [...prev, val]);
        setPatientHistory((prev) => [...prev, val]);
      } else {
        toast.error(`${val?.name} already exist`);
      }
    } else if (data?.label === "Billing") {
      const isAlreadyExist = billingServices?.findIndex(
        (adc) => adc?.id === val?.id
      );
      if (isAlreadyExist === -1) {
        const service = {
          discount: 0,
          discount_type: "percentage",
          price: val?.price,
          type: "Amt",
          description: val?.name_of_service,
          quantity: 1,
          sub_lines: [],
          uom: "",
          total: val?.price,
          line_service: val?.id,
          line_package: null,
        };
        setItems((prev) => [...prev, service]);
        setBillingServices((prev) => [...prev, service]);
      } else {
        toast.error(`${val?.name_of_service} already exist`);
      }
    } else {
      const isAlreadyExist = customfields?.findIndex((adc) => {
        if (
          adc?.id &&
          val?.id &&
          adc?.id === val?.id &&
          adc?.tag_type?.includes(data?.tagId)
        ) {
          return true;
        }
        if (
          adc?.name?.trim()?.toUpperCase() ===
            val?.name?.trim()?.toUpperCase() &&
          adc?.tag_type?.includes(data?.tagId)
        ) {
          return true;
        }
      });
      if (isAlreadyExist === -1) {
        const modifiedTag = {
          id: val?.id,
          name: val?.name,
          value: val?.value,
          tag_type: [data?.tagId],
        };
        setItems((prev) => [...prev, modifiedTag]);
        setCustomfields((prev) => [...prev, modifiedTag]);
      } else {
        toast.error(`${val?.name} already exist`);
      }
    }
    setSearchInput("");
  };

  const handleClose = (idx) => {
    setItems((prev) => {
      const filteredData = [...prev];
      filteredData?.splice(idx, 1);
      return filteredData;
    });
    if (data?.label === "Patient History") {
      setPatientHistory((prev) => {
        const filteredData = [...prev];
        filteredData?.splice(idx, 1);
        return filteredData;
      });
    } else if (data?.label === "Addictions") {
      setAddictions((prev) => {
        const filteredData = [...prev];
        filteredData?.splice(idx, 1);
        return filteredData;
      });
    } else if (data?.label === "Allergy") {
      setAllergies((prev) => {
        const filteredData = [...prev];
        filteredData?.splice(idx, 1);
        return filteredData;
      });
    } else if (data?.label === "Billing") {
      setBillingServices((prev) => {
        const filteredData = [...prev];
        filteredData?.splice(idx, 1);
        return filteredData;
      });
    } else {
      setCustomfields((prev) => {
        const filteredData = [...prev];
        filteredData?.splice(idx, 1);
        return filteredData;
      });
    }
  };

  // const updateUserDetails = useSecureUpdateItem(ApiEndPoint.USERS);
  // const postAllergy = useCreateItem(ApiEndPoint.QP_CM_ALLERGIES);
  // const postPatientHistory = useCreateItem(ApiEndPoint.QP_CM_PATIENT_HISTORY);
  const postMaster = useCreateItem("master_data/medicine_data/");
  // const postTags = useCreateItem(ApiEndPoint.QP_CM_TAGS);

  const handleAddNewItem = (val) => {
    if (val?.length > 0) {
      const existingTag = customFieldData?.findIndex(
        (tag) => val?.trim()?.toUpperCase() === tag?.name?.trim()?.toUpperCase()
      );

      if (existingTag > -1) {
        handleSelectOption(customFieldData[existingTag]);
        return;
      }

      let payload = {
        // clinic_id: clinic?.id,
        // action: "postTags",
        // frontend: "True",
        tag_type: [data?.tagId],
        name: val,
        value: val,
      };
      if (data?.label === "Addictions") {
        payload = {
          action: "postAddictions",
          backend: "True",
          clinic_id: clinic?.id,
          name: val,
          // recently_used_count: 10,
        };
      }
      if (data?.label === "Allergy") {
        payload = {
          action: "postAllergies",
          backend: "True",
          clinic_id: clinic?.id,
          name: val,
          sort: 0,
          // recently_used_count: 2,
          // status: "active",
          // sort: 2,
        };
      }
      if (data?.label === "Patient History") {
        payload = {
          action: "postMedicalHistory",
          backend: "True",
          clinic_id: clinic?.id,
          name: val,
          // recently_used_count: 7,
        };
      }

      if (
        data?.label === "Patient History" ||
        data?.label === "Allergy" ||
        data?.label === "Addictions"
      ) {
        postMaster.mutate(payload, {
          onSuccess: (data) => {
            // setItems((prev) => [
            //   ...prev,
            //   { id: data?.data?.id, name: data?.data?.name },
            // ]);
            handleSelectOption({ id: data?.data?.id, name: data?.data?.name });
            setSearchInput("");
          },
          onError: (err) => toast.error(err.response.data.message),
        });
      } else {
        // setItems((prev) => [...prev, payload]);
        // setCustomfields((prev) => [...prev, payload]);
        handleSelectOption(payload);
        setSearchInput("");
      }
    }
  };

  const handleKeyEvent = (e) => {
    if (e.key === "ArrowDown" && selectedOption < customFieldData?.length - 1) {
      e.preventDefault();
      setSelectedOption((prev) => prev + 1);
      const selectedOptionElement = optionRef.current[selectedOption + 1];
      if (selectedOptionElement) {
        const containerRect = containerRef.current.getBoundingClientRect();
        const optionRect = selectedOptionElement.getBoundingClientRect();
        if (optionRect.bottom > containerRect.bottom) {
          containerRef.current.scrollTop +=
            optionRect.bottom - containerRect.bottom;
        }
      }
    } else if (e.key === "ArrowUp" && selectedOption > -1) {
      e.preventDefault();
      setSelectedOption((prev) => prev - 1);
      const selectedOptionElement = optionRef.current[selectedOption - 1];
      if (selectedOptionElement) {
        const containerRect = containerRef.current.getBoundingClientRect();
        const optionRect = selectedOptionElement.getBoundingClientRect();
        if (optionRect.top < containerRect.top) {
          containerRef.current.scrollTop -= containerRect.top - optionRect.top;
        }
      }
    } else if (e.key === "Enter") {
      e.preventDefault();
      if (searchInput?.length > 0 && customFieldData?.length > -1) {
        optionRef.current[selectedOption].click();
      }
      // if (searchInput?.length > 0 && customFieldData?.length === 0) {
      //   optionRef.current[0].click();
      // }
      setSelectedOption(0);
    }
  };

  const handleAddGroupData = (group) => {
    setItems((prev) => [...prev, ...group?.group_item]);
    setCustomfields((prev) => [...prev, ...group?.group_item]);
  };

  const handleRemarkChange = (e, idx) => {
    setItems((prev) => {
      const temp = [...prev];
      temp[idx].remark = e.target.value;
      return temp;
    });
    setCustomfields((prev) => {
      const temp = [...prev];
      temp[idx].remark = e.target.value;
      return temp;
    });
  };

  return (
    <div className="cu-consultation-customfield-container">
      <div className="cu-consultation-customfield">
        <div className="cu-consultation-customfield-label-cont">
          <label className="cu-consultation-customfield-label">
            {capitalizeFirstWord(data?.label)}
          </label>
          {data?.label !== "Addictions" &&
            data?.label !== "Allergy" &&
            data?.label !== "Patient History" && (
              <OtherIcons
                type={"customTags"}
                tagId={data?.tagId}
                data={items}
                setData={handleAddGroupData}
              />
            )}
        </div>
        <div className="cu-consultation-customfield-input">
          {/* <CuDropdown
            options={options}
            searchable
            capitalize
            clearSearch
            style={{ height: "100%", borderRadius: "6px", width: "100%" }}
            onSearch={handleSearch}
            onChange={handleSelectOption}
            allowAdditions
            onAddItem={handleAddNewItem}
            id={"consultation"}
            loading={isLoading}
          /> */}
          <CuInput
            loading={isLoading}
            position="calc(50% - 10px)"
            onChange={(e) => handleSearch(e.target.value.toUpperCase())}
            value={searchInput}
            onKeyDown={handleKeyEvent}
          />
          {searchInput?.length > 0 && (
            <div
              className="cu-consultation-customfield-suggestion-list"
              ref={containerRef}
            >
              {searchInput?.length > 0 &&
                data?.offset !== "CLINIC_SERVICES" && (
                  <div
                    className={`cu-consultation-customfield-suggestion-list-item ${
                      selectedOption === -1
                        ? "cu-consultation-customfield-suggestion-list-item-active"
                        : ""
                    }`}
                    onClick={() => handleAddNewItem(searchInput)}
                    ref={(el) => (optionRef.current[-1] = el)}
                  >
                    Add New
                  </div>
                )}
              {customFieldData?.map((advc, idx) => {
                return (
                  <div
                    className={`cu-consultation-customfield-suggestion-list-item ${
                      selectedOption === idx
                        ? "cu-consultation-customfield-suggestion-list-item-active"
                        : ""
                    }`}
                    onClick={() => handleSelectOption(advc)}
                    ref={(el) => (optionRef.current[idx] = el)}
                    key={advc?.id}
                  >
                    {data?.offset === "CLINIC_SERVICES"
                      ? advc?.name_of_service
                      : advc?.name}
                  </div>
                );
              })}
            </div>
          )}
        </div>

        <div className="w-[76%]">
          <div className="cu-consultation-customfield-selected-tags">
            {items?.map((itm, idx) => {
              return data?.label?.trim()?.toUpperCase() === "COMPLAINTS" ? (
                <Popup
                  trigger={
                    <div
                      className="cu-consultation-customfield-selected-tag"
                      key={idx}
                    >
                      <span className="cu-consultation-customfield-selected-tag-title">
                        {itm?.name}
                      </span>
                      <span
                        onClick={() => handleClose(idx)}
                        style={{ cursor: "pointer" }}
                      >
                        <img
                          src={CLOSE_ICON}
                          alt="..."
                          width={"25px"}
                          height={"25px"}
                        />
                      </span>
                    </div>
                  }
                  content={
                    <div>
                      <h5>{itm?.name}</h5>
                      <label>Number of days since complaint experienced</label>
                      <CuInput
                        value={itm?.remark}
                        onChange={(e) => handleRemarkChange(e, idx)}
                      />
                    </div>
                  }
                  hoverable
                />
              ) : (
                <div
                  className="cu-consultation-customfield-selected-tag"
                  key={idx}
                >
                  <span>
                    {data?.offset === "CLINIC_SERVICES"
                      ? itm?.description
                      : itm?.name}
                  </span>
                  <span
                    onClick={() => handleClose(idx)}
                    style={{ cursor: "pointer" }}
                  >
                    <img
                      src={CLOSE_ICON}
                      alt="..."
                      width={"25px"}
                      height={"25px"}
                    />
                  </span>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CustomField;
